/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getProviderDetails } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetProviderDetails(location: string, slug: string, options?: UseQueryOptions) {
  return useQuery({
    queryKey: userQueryKeys.providerDetails(location, slug),
    queryFn: () => getProviderDetails(location, slug).then((res) => res.data),
    ...options,
  });
}
